import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Ows from "../../utils/OwsHandler";

interface FetchNote {
  entityId: number;
  objectUid: string;
}

interface NotesState {
  notes: any[];
  loading: boolean;
  error: string | null;
}

const initialState: NotesState = {
  notes: [],
  loading: false,
  error: null,
};

export const fetchNotes = createAsyncThunk(
  "notes/fetch",
  async ({ entityId, objectUid }: FetchNote, { rejectWithValue }) => {
    try {
      const { response } = await Ows.handleRequest("Otys.Services.DossierService.getList", [
        {
          objectEntityId: entityId,
          objectUid: objectUid,
          restrictClass: ["Notes"],
          limit: 15,
          offset: 0,
        },
      ]);
      const detailResponse = response.map((note) => ({
        method: "Otys.Services.NoticeService.getDetail",
        args: [note.id_rec, { text: 1 }],
      }));

      const { response: details } = await Ows.handleMultiRequest(detailResponse);
      return response.map((note, index) => ({
        ...note,
        text: details[index].data.text,
      }));
    } catch (error) {
      return rejectWithValue("Failed to fetch notes.");
    }
  }
);

const notesSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {
    resetNotes: (state) => {
      state.notes = [];
      state.loading = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotes.fulfilled, (state, action) => {
        state.notes = action.payload;
        state.loading = false;
      })
      .addCase(fetchNotes.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export const { resetNotes, clearError } = notesSlice.actions;

export default notesSlice.reducer;
